import {useEffect} from 'react';

import {useViewer} from '../state/viewer/hooks';

const enum IntercomAppId {
  WEAVE = 'k3vi0wc0',
  AUTOMATIONS = 'y230nsyv',
}

function IntercomChatButton(appId: string) {
  const viewer = useViewer();
  // There is a potential case where the Intercom script is not loaded yet
  // and viewer is available first. In that case the component might not render the intercom button.
  // window.Intercom is not reactive, and therefore on load will not cause component to rerender
  // Viewer should load slower, so this should not be a problem
  const intercom = (window as any).Intercom;
  const isIntercomLoaded = intercom && viewer;

  // After intercom is loaded, boot the intercom instance with the viewer's name and email
  useEffect(() => {
    if (isIntercomLoaded) {
      intercom('boot', {
        api_base: 'https://api-iam.intercom.io',
        app_id: appId,
        name: viewer.name || 'n/a', // Full name
        email: viewer.email || 'n/a', // the email for your user
      });
    }
    return () => {
      if (isIntercomLoaded) {
        intercom('shutdown');
      }
    };
  }, [appId, viewer, intercom, isIntercomLoaded]);

  return null;
}

export const WeaveIntercomChatButton = () => {
  return IntercomChatButton(IntercomAppId.WEAVE);
};

export const AutomationsIntercomChatButton = () => {
  return IntercomChatButton(IntercomAppId.AUTOMATIONS);
};
